import { createFileRoute, Outlet } from '@tanstack/react-router';
import type { JSX } from 'react';

import { MonitoringRootLayout } from '@/areas/market-insights/MarketInsights/app/MonitoringRootLayout';
import { canViewMonitoring } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

// Stays mounted across monitoring pages, with its tRPC client and jotai store; its access gates every page below.
export const Route = createFileRoute('/_authenticated/monitoring')({
    // Who may open the Insights pages.
    staticData: { access: { permissions: canViewMonitoring }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return (
        <MonitoringRootLayout>
            <Outlet />
        </MonitoringRootLayout>
    );
}
